<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-2">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <img src="@/assets/img/oil-truck.svg" width="" />
                  </div>
                </div>
                <div class="col-md-6 remove-padding-left padding_div_1">
                  <div class="">
                    <h4 class="text-white mobile_text">
                      {{ $t("text.iTanksFilled.title") }} ({{
                        TanksFilledCount
                      }})
                    </h4>
                  </div>
                  <div class="mt-5">
                    <h5 class="text-white mt-1 mobile_text_para">
                      {{ $t("text.iTanksFilled.getReports") }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-3 remove-padding-left padding_div">
                  <div class="">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      color="#370F70"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="dashboard__table__section mt-3 m_table_row">
          <div class="branch__sales__text_header">
            <div class="row top_section_row mb-3" style="border-radius: 20px">
              <div class="col-md-8">
                <span
                  >{{ $t("text.iTanksFilled.tanksFilledOn") }}
                  {{
                    $d(new Date(startDate), "short", this.$root.$i18n.locale)
                  }}
                  -
                  {{
                    $d(new Date(endDate), "short", this.$root.$i18n.locale)
                  }}</span
                >
              </div>
              <div class="col-md-4 text-right"></div>
            </div>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  field="tank"
                  width="180"
                  :headerText="$t('text.iTanksFilled.tankName')"
                ></e-column>
                <e-column
                  field="filledVolume"
                  width="260"
                  :headerText="$t('text.iTanksFilled.eVolumeDischarged')"
                ></e-column>

                <!-- <e-column field="variance" width="180" :headerText="$t('text.iTanksFilled.variance')"></e-column> -->
                <e-column
                  field="startVolume"
                  width="200"
                  :headerText="$t('text.iTanksFilled.eStartVolume')"
                ></e-column>
                <e-column
                  field="endVolume"
                  width="200"
                  :headerText="$t('text.iTanksFilled.eVolumeEnd')"
                ></e-column>

                <e-column
                  field="startTime"
                  width="250"
                  :headerText="$t('text.iTanksFilled.startTime')"
                ></e-column>
                <e-column
                  field="endTime"
                  width="300"
                  :headerText="$t('text.iTanksFilled.endTime')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Tanks Filled:: Epump Industrial Portal",
  name: "Tanks Filled",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      showLoader: false,
      TanksFilledCount: 0,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      startDate: this.$moment().subtract(70, "days").format("MMMM D, YYYY"),
      backImg,
      industryBranch: null,
      endDate: this.$moment().format("MMMM D, YYYY"),
      industryBranchId: null,
      showLoader: false,
      pluginStartDate: this.$moment().subtract(700, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      dateRange: {
        start: this.$moment().subtract(7, "days").format("D-M-YYYY"),
        end: this.$moment().format("D-M-YYYY"),
      },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      trackOrderTemplate: function () {
        return {
          template: Vue.component("trackOrderTemplate", {
            template:
              '<button class="btn btn_theme" style="background: #370F70 !important ">Track Order</button>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {},
          }),
        };
      },
      inTransitTemplate: function () {
        return {
          template: Vue.component("trackOrderTemplate", {
            template: `
                        <div class="row align-items-center" style="margin: 0 auto">
                            <div class="col-md-1">
                                <span class="round_yellow_pointer"></span>
                            </div>
                            <div class="col-md-2">
                                <span class="">In Transit</span>
                            </div>
                        </div>
                    `,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {},
          }),
        };
      },
    };
  },
  created() {
    //this.dateRange = this.pluginStartDate;
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  watch: {
    // dateRange: function(newDate) {
    //   if (newDate) {
    //     this.startDate = this.$moment(newDate, "DD-MM-YYYY").format(
    //       "MMMM D, YYYY"
    //     );

    //     this.getTanksFilled();
    //   }
    // },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getTanksFilled();
      }
    },
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getTanksFilled();
      }
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    if (screen.width <= 575) {
      document
        .querySelector(".padding_div")
        .classList.remove("remove-padding-left");
      document
        .querySelector(".padding_div_1")
        .classList.remove("remove-padding-left");
    }
  },
  methods: {
    getTanksFilled() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TankFills/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.TanksFilledCount = response.data.length;
          this.showLoader = false;
          let index = 0;
          let filledList = [];
          response.data.sort((a, b) => {
            return a.tankName > b.tankName
              ? 1
              : a.tankName < b.tankName
              ? -1
              : 0;
          });
          response.data.forEach((element) => {
            let startVolume = element.startVolume;
            let endVolume = element.endVolume;
            let filledVolume = element.filledVolume;
            let manualStartVolume = element.manualStartVolume;
            let manualEndVolume = element.manualEndVolume;
            let manualFilledVolume = element.manualFilledVolume;
            index++;
            element.index = index;
            element.startVolume = this.convertThousand(startVolume);
            element.manualStartVolume =
              manualStartVolume === null
                ? "N/A"
                : this.convertThousand(manualStartVolume);
            element.endVolume = this.convertThousand(endVolume);
            element.manualEndVolume =
              manualEndVolume === null
                ? "N/A"
                : this.convertThousand(manualEndVolume);
            element.filledVolume = this.convertThousand(filledVolume);
            element.manualFilledVolume =
              manualFilledVolume === null
                ? "N/A"
                : this.convertThousand(manualFilledVolume);
            element.variance =
              manualFilledVolume === null
                ? "N/A"
                : this.convertThousand(filledVolume - manualFilledVolume);
            element.startTime = this.$moment(element.startTime).format(
              "MMM Do YYYY, h:mm a"
            );
            element.endTime = this.$moment(element.endTime).format(
              "MMM Do YYYY, h:mm a"
            );
            filledList.push(element);
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: filledList,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
